// extracted by mini-css-extract-plugin
module.exports = {"weightUs":"ordersPage_lbOzInput_weightUs__3IN9_"};